// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClusterSpecInput } from './ClusterSpecInput';
import {
  ClusterSpecInputFromJSON,
  ClusterSpecInputFromJSONTyped,
  ClusterSpecInputToJSON,
  ClusterSpecInputToJSONTyped,
} from './ClusterSpecInput';

/**
 *
 * @export
 * @interface UpdateClusterSpec
 */
export interface UpdateClusterSpec {
  /**
   *
   * @type {ClusterSpecInput}
   * @memberof UpdateClusterSpec
   */
  spec?: ClusterSpecInput;
}

/**
 * Check if a given object implements the UpdateClusterSpec interface.
 */
export function instanceOfUpdateClusterSpec(
  value: object,
): value is UpdateClusterSpec {
  return true;
}

export function UpdateClusterSpecFromJSON(json: any): UpdateClusterSpec {
  return UpdateClusterSpecFromJSONTyped(json, false);
}

export function UpdateClusterSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateClusterSpec {
  if (json == null) {
    return json;
  }
  return {
    spec:
      json['spec'] == null ? undefined : ClusterSpecInputFromJSON(json['spec']),
  };
}

export function UpdateClusterSpecToJSON(json: any): UpdateClusterSpec {
  return UpdateClusterSpecToJSONTyped(json, false);
}

export function UpdateClusterSpecToJSONTyped(
  value?: UpdateClusterSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    spec: ClusterSpecInputToJSON(value['spec']),
  };
}
